import useSWR from "swr";
import {
  SubscriptionOffering,
  toSubscriptionOfferings,
} from "../utils/to_subscription_offerings";

interface UseSubscriptionOfferingsQueryReturn {
  data: SubscriptionOffering[] | undefined;
  isValidating: boolean;
  mutate: (data?: any, shouldRevalidate?: boolean | undefined) => Promise<any>;
}

export function useSubscriptionOfferingsQuery(
  partnerId: string,
  subscriptionId: string
): UseSubscriptionOfferingsQueryReturn {
  const { data, isValidating, mutate } = useSWR(
    `/api/v3/portal/partners/${partnerId}/subscriptions/${subscriptionId}/offerings`
  );

  return {
    data: data?.data?.map(toSubscriptionOfferings),
    isValidating,
    mutate,
  };
}
